import BookingSummary from './BookingSummary';

export default BookingSummary;
